import { __awaiter, __generator } from "tslib";
import React, { useEffect, useState } from "react";
import { BannerError, SubmitError, TemplateCreateType, } from "../shared/types";
import { useTranslations } from "../utils";
import Modal from "@adsk/alloy-react-modal";
import Button, { LinkButton } from "@adsk/alloy-react-button";
import { DuplicateNameError, InvalidNameError, NameTooLongError, } from "../shared/errors";
import { CancelConfirmation } from "../shared/components/CancelConfirmation";
import { FooterButton, ModalBody, ModalComponent, ModalHeader, } from "../shared/SharedCreateTemplateModal.styles";
import { ProjectTemplateCreateInSettingsDataInputModal } from "./components/ProjectTemplateCreateInSettingsDataInputModal";
import { AnalyticsEvents } from "../shared/constants";
export var CreateTemplateInSettingsModal = function (props) {
    var T = useTranslations().T;
    var _a = useState(""), templateName = _a[0], setTemplateName = _a[1];
    var _b = useState(false), isSubmitting = _b[0], setIsSubmitting = _b[1];
    var _c = useState(false), isConfirming = _c[0], setIsConfirming = _c[1];
    var _d = useState(undefined), submitError = _d[0], setSubmitError = _d[1];
    var _e = useState(undefined), bannerError = _e[0], setBannerError = _e[1];
    var _f = useState(false), isErrorOpen = _f[0], setIsErrorOpen = _f[1];
    var onErrorClose = function () {
        setIsErrorOpen(false);
        setBannerError(undefined);
    };
    // Computed properties
    var canSubmit = templateName.length > 0;
    // Side effects
    // Side effect - When the template name changes, dismiss the inputError
    useEffect(function () {
        setSubmitError(undefined);
    }, [templateName]);
    // Side effect - When open becomes false, clear the state
    useEffect(function () {
        if (!props.open) {
            // Clear state
            setTemplateName("");
            setIsSubmitting(false);
            setIsConfirming(false);
            setSubmitError(undefined);
            setBannerError(undefined);
            setIsErrorOpen(false);
        }
    }, [props.open]);
    // Helper functions
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var createTemplateRequest, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsSubmitting(true);
                    createTemplateRequest = {
                        name: templateName,
                        accountId: props.account.id,
                        type: TemplateCreateType.FromProject,
                        projectId: props.project.id,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, props.onSubmit(createTemplateRequest)];
                case 2:
                    _a.sent();
                    props.track &&
                        props.track(AnalyticsEvents.createTemplateInSettingsModal.submit.success);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    // Catch the error and evaluate if it matches an error that is can be remediated by the
                    // user.  If so, set the appropriate inputError.
                    if (error_1 instanceof DuplicateNameError) {
                        setSubmitError(SubmitError.DuplicateName);
                        setBannerError(BannerError.Name);
                        setIsErrorOpen(true);
                        props.track &&
                            props.track(AnalyticsEvents.createTemplateInSettingsModal.submit
                                .duplicateNameError);
                    }
                    else if (error_1 instanceof InvalidNameError) {
                        setSubmitError(SubmitError.InvalidName);
                        setBannerError(BannerError.Name);
                        setIsErrorOpen(true);
                        props.track &&
                            props.track(AnalyticsEvents.createTemplateInSettingsModal.submit
                                .invalidNameError);
                    }
                    else if (error_1 instanceof NameTooLongError) {
                        setSubmitError(SubmitError.NameTooLong);
                        setBannerError(BannerError.Name);
                        setIsErrorOpen(true);
                        props.track &&
                            props.track(AnalyticsEvents.createTemplateInSettingsModal.submit
                                .nameTooLongError);
                    }
                    else {
                        setSubmitError(SubmitError.Other);
                        setBannerError(BannerError.Other);
                        setIsErrorOpen(true);
                        props.track &&
                            props.track(AnalyticsEvents.createTemplateInSettingsModal.submit.otherError);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var onClose = function () {
        if (templateName) {
            setIsConfirming(true);
        }
        else {
            props.onClose();
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(CancelConfirmation, { open: props.open && isConfirming, onClose: function () { return setIsConfirming(false); }, onConfirm: function () {
                // Note: When the user confirms, _both_ modals need to be dismissed
                setIsConfirming(false);
                props.onClose();
            } }),
        props.open && !isConfirming && (React.createElement(ModalComponent, { "data-testid": "CreateTemplateInSettingsModal", open: props.open && !isConfirming, onClose: onClose },
            React.createElement(ModalHeader, { "data-testid": "CreateTemplateInSettingsModal.Header" },
                T.translate("genericStrings.saveAsTemplate"),
                React.createElement(Modal.Close, { "data-testid": "CreateTemplateInSettingsModal.CloseButton", onClick: function () {
                        props.track &&
                            props.track(AnalyticsEvents.createTemplateInSettingsModal
                                .closeModalFromHeader);
                        onClose();
                    } })),
            React.createElement(ModalBody, { "data-testid": "CreateTemplateInSettingsModal.Body" }, React.createElement(ProjectTemplateCreateInSettingsDataInputModal, { name: templateName, onNameChange: setTemplateName, account: props.account, isSubmitting: isSubmitting, project: props.project, sumbitError: submitError, bannerError: bannerError, isErrorOpen: isErrorOpen, onErrorClose: onErrorClose })),
            React.createElement(Modal.Footer, null, React.createElement(React.Fragment, null,
                React.createElement(FooterButton, null,
                    React.createElement(LinkButton, { "data-testid": "CreateTemplateInSettingsModal.Footer.CancelButton", onClick: function () {
                            onClose();
                            props.track &&
                                props.track(AnalyticsEvents.createTemplateInSettingsModal
                                    .cancelButton);
                        } }, T.translate("navigation.cancel"))),
                React.createElement(Button, { "data-testid": "CreateTemplateInSettingsModal.Footer.SubmitButton", variant: "primary", loading: isSubmitting, disabled: !canSubmit || isSubmitting || !!submitError, onClick: function () {
                        props.track &&
                            props.track(AnalyticsEvents.createTemplateInSettingsModal
                                .submitButton);
                        onSubmit();
                    } }, T.translate("genericStrings.saveAsTemplate"))))))));
};
